<template>
	<section class="detail-panel-item-picture">
		<div :class="['detail-panel-item-picture__picture']" :style="style"></div>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'detail-panel-item-picture',
	props: {
		src: {
			type: String,
			default: null
		}
	},
	computed: {
		picture () {
			if (this.src)
				//return `http://localhost:8080/files/users/${this.currentUser.uid}/files/${this.src}/`
				return `/api/files/users/${this.currentUser.uid}/files/${this.src}/`

			return '/static/img/account-profile-icon--invert.png'
		},
		style () {
			return `background-image:url('${this.picture}')`
		},
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	}
}
</script>

<style>
.detail-panel-item-picture {
	padding: 10px 0;
	position: relative;
	width: 100%;
	max-width: 256px;
}
.detail-panel-item-picture::after {
	content: ' ';
	display: block;
	padding: 100% 0 0 0;
}
.detail-panel-item-picture__picture {
	background: #333;
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-repeat: no-repeat;
	background-position: top center;
	background-size: cover;
}
</style>


// WEBPACK FOOTER //
// src/modules/ui/DetailPanelItemPicture.vue